
import { utils } from 'apprise-core/utils';
import { useEnv } from 'apprise-frontend-core/env';
import { UpgradeProvider, useUpgrade } from 'apprise-frontend-events/context';
import { EventSubscriber } from 'apprise-frontend-events/subscriptions';
import { ComponentProps, PropsWithChildren } from 'react';


// registers for deployment notifications, marking the session stale if deployed versions are upgrades.
// UI components like <UpgradeButton> react to stalesness and alert the user.

// may be configured either with the current version and/or the upgrade check.
// by default the version is 'latest' but clients may:
// 1. inject it at build-time, if they have it.
// 2. fetch it across the network, if the don't have it.
// 3. customise the check instead of passing in a version

export const defaultUpgradeTopic = 'upgrade'

export type UpgradeObserverConfig = {

    topic?: string
    versions?: string | string[]
    upgradeIf?: (_: string) => boolean

}

export const UpgradeObserver = (props: PropsWithChildren<UpgradeObserverConfig>) => {

    return <UpgradeProvider>
        <Inner {...props} />
    </UpgradeProvider>

}

type AppLifecycleEvent = {

    version: string
}


export const Inner = (props: ComponentProps<typeof UpgradeObserver>) => {

    const { version: current } = useEnv()

    // by default, we compare to the current version.
    const { children, versions = current, topic = defaultUpgradeTopic } = props

    // by default, we upgrade if no version is included in the deployed version.
    const defaultUpgradeCheck = (v: string) => versions && !utils().arrayOf(versions).some(cc => v.includes(cc))

    const { upgradeIf = defaultUpgradeCheck } = props

    const upgrade = useUpgrade()

    const checkUpgrade = (e: AppLifecycleEvent) => {

        if (e.version === undefined || !upgradeIf(e.version))
            return

       upgrade.set(s => s.stale=true)

    }

    return <EventSubscriber name={`app-lifecycle-listener`} subscriptions={[{ topic, onEvent: checkUpgrade }]}>
        {children}
    </EventSubscriber>


}
